<script setup>
import { computed } from 'vue'
import { useUserStore } from '@/stores/UserStore'

const userStore = useUserStore()

// The dealer's first name, whole; a record with only a full name gives its first word, one with neither keeps the question alone.
const firstName = computed(() => userStore.user?.first_name?.trim() || (userStore.user?.name ?? '').trim().split(' ')[0])
</script>

<template>
  <!-- Figma sets the mark 8px above the line, both centred, on the panel's 16px gutter. -->
  <div class="flex flex-col items-center gap-y-2 px-4">
    <span class="flex size-10 items-center justify-center rounded-full bg-blue-50">
      <!-- The glyph is 24 × 20.8, not square; sizing it `size-6` would stretch it. -->
      <Icon icon="cdp:support-chat" class="h-[20.8px] w-6 shrink-0 text-tint-1" />
    </span>

    <!-- Figma breaks the line after the greeting. -->
    <p class="text-center text-xl font-semibold text-gray-900">
      <template v-if="firstName">Hi, {{ firstName }}.<br /></template>How can I help you with?
    </p>
  </div>
</template>
